const NetworkDetectionsFileName = (props) => {
  const fileName = props?.row?.original?.file_name || "-";

  return <span>{fileName}</span>;
};

export default NetworkDetectionsFileName;
